import React from 'react'
import './empty.css'

const Empty = ({text, icon}) => {

      return (
            <div className="empty_content flex">
                  <div className="empty_icon flex">
                        {icon}
                  </div>
                  <h2>Oops!</h2>
                  <p>{text}</p>
            </div>
      )
}

export default Empty
